import {default as proj} from 'proj4';
import {register} from "ol/proj/proj4";

export const proj4 = proj;

if (!proj4.defs("EPSG:2193")) {
    // proj4.defs("EPSG:2193","+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu");
    proj4.defs("EPSG:2193","+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu");
}

/**
 * The same projection as above.
 *
 * Openlayers will encode our EPSG:2193 projection geometry with y/x ordering but WFS servers will interpret EPSG:2193 to mean x/y ordering
 * So we use urn:x-ogc:def:crs:EPSG:2193 to tell the WFS that the encoded geometry is y/x ordered
 */
if (!proj4.defs("urn:x-ogc:def:crs:EPSG:2193")) {
    proj4.defs("urn:x-ogc:def:crs:EPSG:2193","+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu");
}

if (!proj4.defs("urn:ogc:def:crs:EPSG:2193")) {
    proj4.defs("urn:ogc:def:crs:EPSG:2193","+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu");
}

self['proj4'] = proj4;

register(proj4);